<template>
  <div style="background-color: #f1f1f1; overflow: hidden">
    <div class="main_top">
      <div>
        <img class="title_img" src="~@/assets/logo2.png" alt="" />
      </div>
      <div class="title">
        <!-- 欢迎登录 -->
        <div class="header-current_time">{{ date | zhDatetime }}</div>
        <div class="user">
          <img style="margin-left: 1rem; width: 1.8rem; height: 1.8rem; cursor: pointer" src="~@/assets/头像 copy 2.png" alt="" />
          <div class="header-right_content">
            <!-- <div class="user-head_portrait">
              </div>-->
            <!-- <el-avatar size="medium" src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
              class="user-header-img"></el-avatar> -->
            <div class="user-fun-container">
              <el-dropdown>
                <span class="el-dropdown-link" style="display: flex">
                  <span
                    style="
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      margin-left: 0.1rem;

                      color: #ffffff;
                      display: block;
                    "
                    >{{ user_name }}</span
                  >
                  <i style="line-height: 58px; color: #ffffff; margin-left: 0.3rem" class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu class="user-funDropdown-container" slot="dropdown">
                  <el-dropdown-item @click.native="changePassowrd()">
                    <span class="FontFamily el-icon-erp el-icon-erp-changepassword"></span>
                    <span class="user-fun-text">修改密码</span>
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="loginOut()">
                    <span class="FontFamily el-icon-erp el-icon-erp-tuichu"></span>
                    <span class="user-fun-text">退出系统</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
        <!-- <div style="margin-left: 1.2rem;font-size: 15px;">
          帮助
        </div> -->
        <div class="header_title" style="margin-left: 1rem; font-size: 15px; cursor: pointer" @click="getTo_xt">帮助文档</div>
      </div>
    </div>
    <div class="main_title">
      <div style="display: flex; justify-content: center; margin-top: 0.8rem">
        <img style="width: 98vw; height: 315px" src="~@/assets/ngvT.png" alt="" />
      </div>
    </div>
    <div class="main_bottom">
      <div style="display: flex; height: 100%">
        <div style="width: 55%; height: 100%">
          <div class="left">
            <!-- <div class="left_top">
              办理事项
            </div> -->
            <div class="left_bottom">
              <div @click="getTo(item.path, item.role)" v-for="(item, index) in pathList" :key="index" class="item_box">
                <div>
                  <img style="width: 5rem; margin-right: 1rem; margin-left: 1rem" :src="item.src" alt="" />
                </div>
                <div>{{ item.title }}</div>
              </div>
            </div>
            <div></div>
          </div>
        </div>
        <div style="width: 45%; height: 100%">
          <div class="right">
            <div style="display: flex; height: 96%">
              <div style="width: 50%; height: 100%">
                <div class="right_bottom">
                  <div class="top" style="display: flex; justify-content: space-between">
                    <div style="display: flex">
                      <img src="../../assets/images/a1.png" alt="" />
                      <div style="font-weight: bold; margin-left: 0.7rem; color: #333333; cursor: pointer; font-size: 18px" @click="getMore('seven')">农事记录</div>
                    </div>
                    <div class="more" style="margin-right: 0.3rem; color: #666666; cursor: pointer" @click="getMore('seven')">查看更多></div>
                  </div>
                  <div class="gj_title">
                    <div class="gj_bottom" v-for="(item, index) in farmList" :key="item.id">
                      <div class="citle a2">
                        <img class="citle" :src="item.workTypeImage" alt="" />
                      </div>
                      <div class="gj_title_">
                        <div style="margin-bottom: 10px">
                          <span style="font-size: 15px">
                            <span style="font-weight: bold; color: #333333"> {{ item.workTypeName }} — {{ item.cropName }} — {{ item.groupName }} </span>
                          </span>
                          <!-- <img style="margin-right: 0.3rem;width: 1.1rem;height: 1.3rem;" :src="item.url" alt=""> -->
                        </div>
                        <div class="title_farm" style="font-size: 12px; color: #666666; margin-bottom: 10px; text-align: left; font-style: normal">
                          {{ item.workContent }}
                        </div>
                        <div style="width: 100%; font-weight: 400; font-size: 12px; color: #666666; line-height: 17px; text-align: left; font-style: normal">记录时间：{{ item.startTime }}</div>
                        <!-- <div class="right_bottom" style="color: #666666;font-weight: 400;font-size: 14px;margin-top: 0.5rem;margin-right:10px">
                        <div class="time">
                          <div class="name" style="display: flex;justify-content: space-between;">
                            <div style="margin-right: 0.8rem; text-overflow: ellipsis;">
                            </div>
                          </div>
                        </div>
                      </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style="width: 50%; height: 100%">
                <div class="right_bottom">
                  <div class="top" style="display: flex; justify-content: space-between">
                    <div style="display: flex">
                      <img src="../../assets/images/a2.png" alt="" />
                      <div style="font-weight: bold; margin-left: 0.7rem; color: #333333; cursor: pointer; font-size: 18px" @click="getMore('seven')">告警记录</div>
                    </div>
                    <div class="more" style="margin-right: 0.3rem; color: #666666; cursor: pointer" @click="getAlarmMore('seven')">查看更多></div>
                  </div>
                  <div class="gj_title">
                    <div class="gj_bottom" v-for="(item, index) in alarmList" :key="item.id">
                      <div class="citle a2">
                        <img class="citle" :src="item.url" alt="" />
                      </div>
                      <div class="gj_title_">
                        <div style="margin-bottom: 10px">
                          <span style="font-size: 14px">
                            <span style="font-weight: bold; color: #333333"> {{ item.alarmType }}- {{ item.deviceName }} </span>
                          </span>
                          <!-- <img style="margin-right: 0.3rem;width: 1.1rem;height: 1.3rem;" :src="item.url" alt=""> -->
                        </div>
                        <div class="title_farm" style="font-size: 12px; color: #666666; margin-bottom: 10px; text-align: left; font-style: normal">告警数值：{{ item.value }} {{ item.symbol }}</div>
                        <div style="width: 100%; font-weight: 400; font-size: 12px; color: #666666; line-height: 17px; text-align: left; font-style: normal">告警时间：{{ item.startTime }}</div>
                        <!-- <div class="right_bottom" style="color: #666666;font-weight: 400;font-size: 14px;margin-top: 0.5rem;margin-right:10px">
                        <div class="time">
                          <div class="name" style="display: flex;justify-content: space-between;">
                            <div style="margin-right: 0.8rem; text-overflow: ellipsis;">
                            </div>
                          </div>
                        </div>
                      </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <changePassowrd ref="passowrd"></changePassowrd>
      </div>
    </div>
  </div>
</template>
<script>
import store from '@/store/index'
import changePassowrd from '@/views/home/changePassowrd'

export default {
  name: 'homePage1',
  components: {
    changePassowrd
  },
  data() {
    return {
      date: new Date(),
      selectCurrentYear: new Date(), // 波段列表保存切换的年份

      user_name: '',
      userType: '',
      pathList: [
        {
          src: require('@/assets/images/ssjc.png'),
          title: '实时监测',
          path: 'homePage',
          role: '01'
        },
        {
          src: require('@/assets/images/rgms.png'),
          title: '远程控制模式',
          path: 'intelligentControl',
          role: '02'
        },
        {
          src: require('@/assets/images/ai.png'),
          title: 'AI自动模式',
          path: 'decisionManagement',
          role: '03'
        },
        {
          src: require('@/assets/images/ds.png'),
          title: '定时控制模式',
          path: 'timedTask',
          role: '08'
        },
        {
          src: require('@/assets/images/tkfx.png'),
          title: '数据分析',
          path: 'growthModelHisParamControlChart',
          role: '04'
        },
        {
          src: require('@/assets/images/nsjl.png'),
          title: '农事记录',
          path: 'growthModel',
          role: '05'
        },
        {
          src: require('@/assets/images/gjgl.png'),
          title: '告警管理',
          path: 'alarmPredictions',
          role: '06'
        },

        {
          src: require('@/assets/images/sbgl.png'),
          title: '设备管理',
          path: 'deviceManagement',
          role: '07'
        },
        {
          src: require('@/assets/images/stgl.png'),
          title: '系统管理',
          path: 'userManagement',
          role: '09'
        }
      ],
      farmList: [],
      alarmList: []
    }
  },
  created() {
    // this.permissionJudge(); // 调用权限判断方法
    this.user_name = sessionStorage.getItem('USER_name')
    this.userType = sessionStorage.getItem('USER_Type')
    this.defaultRouter = this.$route.path
    let _this = this // 声明一个变量指向Vue实例this，保证作用域一致

    this.timer = setInterval(() => {
      _this.date = new Date() // 修改数据date
    }, 1000)
    this.getAlarm()
    this.getFarm()
    this.getAuthority()
    this.getSysUserByToken()
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer) // 在Vue实例销毁前，清除我们的定时器
    }
  },
  methods: {
    getSysUserByToken() {
      this.$api.system.getSysUserByToken().then(res => {
        if (res.code == 200) {
          this.getAuthority(res.data.id)
          window.localStorage.setItem('departId', res.data.departId)
          window.localStorage.setItem('departName', res.data.departName)
          if (res.data.permissions) {
            this.$store.commit('user/SET_PERMISSION', res.data.permissions)
          }
          sessionStorage.setItem('USER_ID', res.data.id)
          sessionStorage.setItem('USER_name', res.data.username)
          sessionStorage.setItem('USER_Type', res.data.userType) // 用户类型 0 管理员 1 普通用户
        }
      })
    },
    //获取详情
    getUserDetails(id) {
      this.$api.system.getUserDetails(id).then(res => {
        if (res.code == 200) {
          console.log(res.data, 3333)
          sessionStorage.setItem('USER_groupID', res.data.groupId)
        }
      })
    },
    getAuthority(id) {
      this.$api.system.getAiUserRoleMenus(id).then(res => {
        if (res.code == 200) {
          let datas = res.data
          let arr = []
          for (let i of datas) {
            if (i.isCheck == 1) {
              arr.push(i.code)
            }
            for (let j of i.nextMenus) {
              if (j.isCheck == 1) {
                arr.push(j.code)
              }
              for (let k of j.nextMenus) {
                if (k.isCheck == 1) {
                  arr.push(k.code)
                }
              }
            }
          }
          let arr1 = JSON.stringify(arr)
          window.localStorage.setItem('arr', arr1)
          let userType = sessionStorage.getItem('USER_Type')
        }
      })
    },
    changePassowrd() {
      this.$refs.passowrd.show()
    },
    getTo_xt() {
      window.open('https://futurefarm.bbyiot.com/agriculture_develop_webservice/static//pdf/1717038037321.pdf')
      // this.$router.push({
      //   name: 'userManagement'
      // })
    },
    getTo(path, role) {
      console.log(path)
      let roles = window.localStorage.getItem('arr')
      console.log(roles)
      roles = JSON.parse(roles)
      roles.map(item => {
        if (role == item) {
          if (path == 'http://192.168.1.112:8080/intelligent_three_dimensional/') {
            let url = 'http://192.168.1.112:8080/intelligent_three_dimensional/#/./?Authorization=' + store.state.user.token
            // window.open = url;
            window.open(`${url}`, '_blank')
          } else if (path == 'growthModel') {
            this.getMore('seven')
          } else {
            this.$router.push({
              name: `${path}`
            })
          }
        }
      })
    },
    getAlarm() {
      let a = {
        pageNum: 1,
        pageSize: 5
      }
      this.$api.groupAlarm.getHomeDataRealAlarmList(a).then(res => {
        this.alarmList = res.data
        this.alarmList.map(item => {
          // item.alam = item.content.split('，')
          // item.alamName = item.alam[1]
          if (item.alarmType.includes('二氧化碳')) {
            item.url = require('@/assets/images/co2.png')
          } else if (item.alarmType.includes('空气温度')) {
            item.url = require('@/assets/images/wd.png')
          } else if (item.alarmType.includes('光照')) {
            item.url = require('@/assets/images/gz.png')
          } else if (item.alarmType.includes('空气湿度')) {
            item.url = require('@/assets/images/sd.png')
          } else if (item.alarmType.includes('P')) {
            item.url = require('@/assets/images/ph.png')
          } else if (item.alarmType.includes('土壤湿度')) {
            item.url = require('@/assets/images/trsd.png')
          } else if (item.alarmType.includes('土壤温度')) {
            item.url = require('@/assets/images/trwd.png')
          } else if (item.alarmType.includes('E')) {
            item.url = require('@/assets/images/ec.png')
          }
        })
        console.log(this.alarmList)
      })
    },
    getFarm() {
      let a = {
        pageNum: 1,
        pageSize: 5
      }
      this.$api.growthModel.getProductionWorkList(a).then(res => {
        this.farmList = res.data
      })
    },
    getMore(activeName) {
      this.$router.push({
        name: 'groupFarm',
        query: {
          activeName: activeName
        }
      })
    },
    getAlarmMore(activeName) {
      this.$router.push({
        name: 'alarmPredictions',
        query: {
          activeName: activeName
        }
      })
    },
    loginOut() {
      let userName = window.localStorage.getItem('userNameZ')
      let pwdZ = window.localStorage.getItem('pwdZ')
      this.$utils.delAllStorage()
      this.$utils.delAllSession()
      if (userName && userName != null) {
        window.localStorage.setItem('userNameZ', userName)
        window.localStorage.setItem('pwdZ', pwdZ)
      }
      this.$router.push({
        name: 'login'
      })
      this.$toaster.ok('退出成功')
    }
  }
}
</script>
<style lang="scss" scoped>
.title_ {
  width: 15rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.right_bottom {
  white-space: nowrap;
  // margin: 10px;
  width: 95%;
  height: 100%;
  background-color: #ffffff;
  .top {
    padding: 10px;
    border-bottom: 1px solid #eeeeee;
  }
}
// 鼠标移入清除省略号
.hover_title[data-title] {
  position: relative;

  // 样式：
  &:hover:after {
    opacity: 1;
    transition: all 0.1s ease 0.5s;
    visibility: visible;
  }

  // 背景的样式 位置 字体等
  &:after {
    content: attr(data-title);
    position: absolute;
    padding: 1px 10px;
    right: -110px;
    bottom: -2.8em;
    height: 2rem;
    line-height: 2rem;
    // right: 0.5rem;
    border-radius: 4px;
    color: #fff;
    background-color: rgba(80, 79, 79, 0.8);
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.16);
    font-size: 14px;
    white-space: nowrap;
    visibility: hidden;
    opacity: 0;
  }
}

.main_top {
  display: flex;
  justify-content: space-between;
  line-height: 60px;
  height: 60px;
  background: #2494f2;

  .title_img {
    // line-height: 5rem;
    margin-top: 15px;
    width: 200px;
    margin-left: 1.5rem;
  }

  .title {
    width: 480px;
    display: flex;
    font-size: 15px;
    font-family: MicrosoftYaHei;
    // font-weight: bold;
    color: #ffffff;
    // margin-top: -1px;
  }
}
.left {
  width: 100%;
  // margin: 1rem;
  margin-top: 1rem;
  margin-left: 1rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  height: 100%;
  .left_top {
    background-color: #ffffff;
    height: 3rem;
    font-weight: bold;
    line-height: 3rem;
    padding-left: 2rem;
    font-size: 15px;
    font-family: MicrosoftYaHei;
    color: #33363b;
  }
}

.left_ {
  width: 400px;
  margin: 1rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  .left_top {
    background-color: #ffffff;
    height: 3rem;
    font-weight: bold;
    line-height: 3rem;
    padding-left: 2rem;
    font-size: 15px;
    font-family: MicrosoftYaHei;
    color: #33363b;
  }
}

.more {
  background: #ffffff;
  border-radius: 16px;
  width: 84px;
  height: 25px;

  border: 1px solid #2494f2;
  color: #2494f2 !important;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  text-align: center;
  font-style: normal;
}

.left_bottom {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  // height: 400px;
  height: 98%;

  .item_box {
    cursor: pointer;
    display: flex;
    align-items: center;
    margin-right: 1rem;
    margin-bottom: 10px;
    // margin-left: 1rem;
    height: 95%;
    padding-left: 1rem;
    // line-height: 13.5rem;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #33363b;
    font-size: 18px;
    background-color: #ffffff;
  }
}

.right {
  // padding-left: 2rem;
  margin: 1rem;
  height: 390px;
  height: 100%;
  width: 98%;
  margin-right: 0rem;
  // background-color: #ffffff;

  .right_top {
    height: 3rem;
    font-family: MicrosoftYaHei;
    color: #33363b;
    font-weight: bold;
    line-height: 3rem;
    font-size: 15px;
    border-bottom: 1px solid #e8e8e8;
  }
}
.name {
  white-space: nowrap;
  overflow-x: auto;
  font-size: 14px;
}
.header-current_time {
  // width: 164px;
  height: 60px;
  font-family: MicrosoftYaHei;
  font-size: 16px;
  line-height: 60px;
  text-align: center;
  font-weight: bold;
  width: 200px;
}
.user {
  display: flex;
  justify-content: center;
  align-items: center;
}
.gj_title {
  display: flex;
  flex-flow: column;
  justify-content: space-around;
  height: 90%;
}
.gj_bottom {
  border-bottom: 1px solid #eeeeee;
  height: 100%;
  display: flex;
  // flex-flow: column;
  // justify-content: space-around;
  align-items: center;
}
.gj_title_ {
  margin-left: 15px;
}
.citle {
  border-radius: 30px;
  width: 22px;
  margin-left: 15px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;

  // background: #ff5858;
  // border: 1px solid #ff5858;
  // color: #ffffff;
  // font-weight: bold;
}
.a2 {
  // background-color: #2494f2;
  // border: 1px solid #2494f2;
}
.main_bottom {
  height: 57vh;
}
.title_farm {
  width: 250px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
